import type { CardPointeNormalizedGatewayTransactionDetails } from './cardpointe/cardpointe-transaction-details.types';
import { CardPointeGatewayTransactionDetailsType } from './cardpointe/cardpointe-transaction-details.types';
import type { CloverNormalizedGatewayTransactionDetails } from './clover/clover-transaction-details.types';
import { CloverGatewayTransactionDetailsType } from './clover/clover-transaction-details.types';
import type { ValorGatewayTransactionDetails } from './valor/valor-payment.types';
import { ValorGatewayTransactionDetailsType } from './valor/valor-payment.types';
import { LosslessNumber } from '../../lossless-json-codec';

export const IPG_GATEWAY_TRANSACTION_DETAILS_TYPE = {
    VALOR: ValorGatewayTransactionDetailsType,
    CARDPOINTE: CardPointeGatewayTransactionDetailsType,
    CLOVER: CloverGatewayTransactionDetailsType,
} as const;

export type IpgGatewayTransactionDetailsType =
    (typeof IPG_GATEWAY_TRANSACTION_DETAILS_TYPE)[keyof typeof IPG_GATEWAY_TRANSACTION_DETAILS_TYPE];

export type IpgGatewayTransactionDetails =
    | ValorGatewayTransactionDetails
    | CardPointeNormalizedGatewayTransactionDetails
    | CloverNormalizedGatewayTransactionDetails;

export function gatewayTransactionDetailsTypeRequiresBaseAmountMatch(
    detailsType: IpgGatewayTransactionDetailsType
): boolean {
    switch (detailsType) {
        case CloverGatewayTransactionDetailsType:
            return false;
        case CardPointeGatewayTransactionDetailsType:
        case ValorGatewayTransactionDetailsType:
            return true;
    }
}

export function gatewayTransactionTipAmount(details: IpgGatewayTransactionDetails): LosslessNumber {
    switch (details.gateway_transaction_details_type) {
        case ValorGatewayTransactionDetailsType:
            switch (details.gateway_transaction_details_version) {
                case 1:
                    return new LosslessNumber('0');
                case 2:
                    return details.tip_amount;
            }
        case CardPointeGatewayTransactionDetailsType:
        case CloverGatewayTransactionDetailsType:
            return new LosslessNumber('0');
    }
}
